/* eslint-disable max-classes-per-file */
/**
 * @typedef {object} CurrentPaymentMethod
 * @property {string} type The payment method type (credit_card, paypal)
 * @property {Number} expiryDate The expiry date of the card, as a timestamp
 * @property {string} label The last 4 digits of the card, or the paypal email
 * @property {Boolean} available If the card is 'available', i.e has data
 * @property {boolean} pastDue
 */
export class CurrentPaymentMethod {
  // FIXME: Please fix this.
  // eslint-disable-next-line func-params-args/func-params
  constructor(type, expiryDate, label, pastDue, nextBillingDate, hasPaidPlan) {
    this.type = type;
    this.expiryDate = expiryDate;
    this.label = label;
    this.available = Boolean(type);
    this.pastDue = pastDue;
    this.nextBillingDate = nextBillingDate;
    this.hasPaidPlan = hasPaidPlan;
  }

  static fromResponse(response) {
    return new CurrentPaymentMethod(
      response.payment_method_type,
      response.card_expiration_date,
      response.payment_method_label,
      response.has_paid_plan && response.failure_count > 0,
      response.next_billing_date,
      response.has_paid_plan,
    );
  }
}

/**
 * @typedef {object} PaymentData
 * @property {SitePlanInfo[]} costSpecs The list of plans to apply.
 * @property {object} [currentPaymentMethod] The current payment method available.
 * @property {string} currentPaymentMethod.label The display text on the current payment method.
 * @property {string} currentPaymentMethod.type The type: one of credit_card, paypal, bank_transfer.
 * @property {Date} currentPaymentMethod.expiryDate When the payment method e.g. credit card expires.
 * @property {boolean} currentPaymentMethod.available Whether we can use it in this context.
 * @property {string} [referrer] The referrer to apply.
 */
export class PaymentData {
  // FIXME: Please fix this. You may refer to CFE-266 for more details.
  // eslint-disable-next-line func-params-args/func-params
  constructor(
    // eslint-disable-next-line default-param-last
    costSpecs = [],
    // eslint-disable-next-line default-param-last
    currentPaymentMethod = new CurrentPaymentMethod(),
    referrer,
    defaultBillingCycle,
  ) {
    this.costSpecs = costSpecs;
    this.currentPaymentMethod = currentPaymentMethod;
    this.referrer = referrer;
    this.defaultBillingCycle = defaultBillingCycle;
  }
}

/**
 * @typedef {object} SitePlanInfo
 * @property {number|string|null} site_id The site ID.
 * @property {string} plan_id The new Plan ID.
 * @property {number|string} [always_on_rate=0] The always-on rate.
 */
export class SitePlanInfo {
  constructor(siteId, planId, alwaysOnRate = 0) {
    this.site_id = siteId;
    this.plan_id = planId;
    this.always_on_rate = alwaysOnRate;
  }
}
